import { SOFTWARE } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice, httpserviceWithMultipart } from '../services';
import { constants } from '../constant/constant';

const FileSaver = require('file-saver');

let apiEndPoint = constants.ADMIN_URL;
const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;
if (loginUser) {
  if (loginUser.role.roleName === 'client') {
    apiEndPoint = constants.CLIENT_URL;
  }
}

export const getSoftwareVersionList = (softwareId) => (dispatch) => {
  dispatch({
    payload: [],
    type: SOFTWARE.VERSION.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.SOFTWARE_VERSION}/${softwareId}`)
    .then((response) => {
      const count = response.data.response ? response.data.response.length : 0;

      const responseData = response.data.response.map((data) => (
        {
          ...data,
          platform: `${data.platform.charAt(0).toUpperCase()}${data.platform.slice(1)}`,
          createdAt: dateFormat(data.createdAt),
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: SOFTWARE.VERSION.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.VERSION.ERROR,
      });
      return error;
    });
};

export const doSoftwareVersionCreate = (data) => httpserviceWithMultipart('post', data, apiEndPoint + constants.API.VERSION);

export const doSoftwareVersionUpdate = (data, id) => httpserviceWithMultipart('put', data, `${apiEndPoint}${constants.API.VERSION}/${id}`);

export const doSoftwareVersionDelete = (info) => httpservice()
  .delete(`${constants.API.VERSION}/${info}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doSoftwareVersionDownload = (rowData) => httpservice()
  .get(
    `${constants.API.DOWNLOAD_VERSION}/${rowData.id}`,
    {
      responseType: 'blob',
    },
  ).then((response) => {
    const blob = new Blob([response.data]);
    FileSaver.saveAs(blob, rowData.releasePath);
    return {};
  }).catch((error) => ({ data: error.response, status: 0 }));
